import {
  Link,
  NavLink,
  Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { Sidebar, MobileBottomBar } from "@/components";
import { SidebarMenu } from "./utils/Data";
import NotificationSideBar from "./pages/Notification/NotificationSideBar";
import { logoutUser } from "./app/slices/userSlice";
import store from "./app/store";
import { initializeSocket, disconnectSocket } from "./services/websocket";
import { useEffect } from "react";
import { logo } from "./assets/svg/Index";
import { useApi } from "@/";

function App() {
  // Get the user object from the Redux store
  const { callApi } = useApi();
  const user = useSelector((state) => state.user?.user) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const walletBalance = useSelector((state) => state.wallet?.balance);
  const [searchParams, setSearchParams] = useSearchParams(); // Add setSearchParams

  /*   useEffect(() => {
    const handleShopifyCallback = async () => {
      const params = Object.fromEntries(searchParams.entries());
      setSearchParams({});
      console.log("Shopify Callback - Search Params:", params);
      console.log("Shopify Callback - Search Params String:", searchParams.toString());
      
      if (params) {
        console.log("Shopify Callback - Entering callback logic");
        const redirectUri =
          "https://app.indiancouriercompany.com/settings/channel";
        const scopes = ["read_orders", "write_orders", "read_all_orders"].join(
          ","
        );
        const clientId = import.meta.env.VITE_SHOPIFY_CLIENT_ID;
        console.log("Shopify Callback - Client ID:", clientId);
        
        const installUrl =
          `https://${params.shop}/admin/oauth/authorize` +
          `?client_id=${clientId}` +
          `&scope=${scopes}` +
          `&redirect_uri=${redirectUri}`;
        console.log("Shopify Callback - Install URL:", installUrl);

        try {
          // Get the session token for authenticated API calls
          console.log("Shopify Callback - Attempting to get session token");
          const sessionToken = await getShopifyToken();
          console.log("Shopify Callback - Session Token Received:", sessionToken ? "Yes" : "No");
          
          console.log("Shopify Callback - Calling API endpoint");
          const response = await callApi(
            "/channel-integration/shopify/auth/callback",
            "POST",
            {
              ...params,
              refreshTokenUrl: installUrl,
              sessionToken: sessionToken, // Include the session token
            }
          );

          console.log("Shopify Callback - API Response:", response);
          if (response.success) {
            console.log("Shopify Integration Response:", response);
            dispatch(updateChannelIO(response.data));
            alert("Shopify store connected successfully.");
            setSearchParams({});
          } else {
            console.log("Shopify Integration Failed:", response);
            alert("Failed to connect Shopify store");
          }
        } catch (e) {
          console.error("Shopify integration error:", e);
          alert("Failed to connect Shopify store: " + e.message);
        }
      } else {
        console.log("Shopify Callback - No search params, skipping callback logic");
      }
    };

    handleShopifyCallback();
  }, [searchParams]); */

  console.log("[Store]:::", store);

  useEffect(() => {
    // Initialize WebSocket when the component mounts
    initializeSocket(store);

    // Clean up on unmount
    return () => {
      disconnectSocket();
    };
  }, []); // Empty dependency array means this runs once on mount

  // Handle logout
  const handleLogout = async () => {
    const resultAction = await dispatch(logoutUser());
    if (logoutUser.fulfilled.match(resultAction)) {
      // Disconnect socket on logout

      disconnectSocket();
      navigate("/login");
    } else {
      // Handle the error case, e.g. show a notification
      console.error("Action:", resultAction);
      console.error("Logout failed:", resultAction.payload);
    }
  };

  return (
    <div className="w-full relative flex h-dvh gap-2 bg-background">
      {/* Sidebar */}
      <Sidebar
        sidebarMenus={SidebarMenu}
        user={{ name: user.name || "------", email: user.email || "------" }}
        logo={logo}
        walletBalance={walletBalance}
        Link={Link}
        NavLink={NavLink}
        useLocation={useLocation}
        NotificationLayout={NotificationSideBar}
        handleLogout={handleLogout} // Pass the logout function to the Sidebar
      />
      {/* Main Content */}

      <div className="w-full h-full flex justify-start overflow-y-auto">
        <Outlet />
      </div>
      {/* Mobile Bottom Bar */}
      <MobileBottomBar
        MenuItems={SidebarMenu}
        NavLink={NavLink}
        useLocation={useLocation}
        NotificationLayout={NotificationSideBar}
        handleLogout={handleLogout} // Pass the logout function to the Sidebar
      />
    </div>
  );
}

export default App;
